import React from 'react';
import classnames from 'classnames';
import GPSelect from '@gp/components/Select';

import type { IBaseProps } from '@home/types/common';
import type { IGranularity } from '../../types';

interface IGranularitySelectProps extends IBaseProps {
  disabled?: boolean;
  options?: IGPSelectOptionWithGroup[];
  value: IGranularity;
  onChange: (value: IGranularity) => void;
}

const DEFAULT_GRANULARITY_OPTIONS: IGPSelectOptionWithGroup[] = [
  {
    value: 'month',
    text: 'Month',
  },
  {
    value: 'quarter',
    text: 'Quarter',
  },
  {
    value: 'year',
    text: 'Year',
  },
];

const GranularitySelect: React.FC<IGranularitySelectProps> = (props) => {
  const { style, className, disabled = false, options = DEFAULT_GRANULARITY_OPTIONS, value, onChange } = props;

  return (
    <GPSelect
      style={{ ...style, width: 100 }}
      className={classnames('dbg-calendar-filter-date-type', className)}
      label=""
      clearable={false}
      disabled={disabled}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export default GranularitySelect;
